import { GetComponentStyleFunc } from './types';

export const muiTextField: GetComponentStyleFunc<'MuiTextField'> = () => {
  return {};
};
